import { Link } from 'react-router-dom';
import { ArrowLeft, User as UserIcon } from 'lucide-react';
import { Button } from './ui/button';

export default function PageHeader({ title, backTo = '/dashboard', user, actions, titleIcon = null }) {
  return (
    <header className="bg-white/80 backdrop-blur-md border-b border-[#EBF0F5] sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-3 sm:px-6 py-3 sm:py-4 flex items-center justify-between gap-2">
        <div className="flex items-center gap-2 sm:gap-4 min-w-0 flex-shrink">
          <Link to={backTo}>
            <Button variant="ghost" size="sm" className="rounded-full h-8 w-8 sm:h-9 sm:w-9 p-0">
              <ArrowLeft className="h-4 w-4 sm:h-5 sm:w-5" />
            </Button>
          </Link>
          {titleIcon && <span className="hidden sm:block">{titleIcon}</span>}
          <h1 className="text-lg sm:text-2xl font-medium bg-gradient-to-r from-[#2B4C7E] to-[#2B4C7E] bg-clip-text text-transparent truncate">
            {title}
          </h1>
        </div>
        
        <div className="flex items-center gap-2 sm:gap-4 flex-shrink-0">
          {actions}
          {user && (
            <Link to="/profile" className="flex items-center gap-2 hover:opacity-80 transition-opacity">
              {user.profile_picture || user.picture ? (
                <img 
                  src={user.profile_picture || user.picture} 
                  alt={user.name}
                  className="w-8 h-8 sm:w-10 sm:h-10 rounded-full object-cover border-2 border-[#D7E0EA]"
                />
              ) : (
                <div className="w-8 h-8 sm:w-10 sm:h-10 bg-gradient-to-br from-[#EBF0F5] to-[#D7E0EA] rounded-full flex items-center justify-center border-2 border-[#D7E0EA]">
                  <UserIcon className="h-4 w-4 sm:h-5 sm:w-5 text-[#2B4C7E]" strokeWidth={2} />
                </div>
              )}
            </Link>
          )}
        </div>
      </div>
    </header>
  );
}
